import { render, staticRenderFns } from "./BattlesFilterMode.vue?vue&type=template&id=518e54ea&scoped=true"
import script from "./BattlesFilterMode.vue?vue&type=script&lang=js"
export * from "./BattlesFilterMode.vue?vue&type=script&lang=js"
import style0 from "./BattlesFilterMode.vue?vue&type=style&index=0&id=518e54ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518e54ea",
  null
  
)

export default component.exports